import React, { useState, useContext } from 'react';
import {ApplicationContext} from "../../Provider/ApplicationProvider";
import AppConfig from '../../config/AppConfig';
import Swal from "sweetalert2";
export default function AppForm({title}){
    const {updateApp, updateAccount}=useContext(ApplicationContext);
    const minLength = 200;
    const [name, setName] = useState('');
    const [description, setDescription] = useState('');
    const apiUrl = AppConfig.API_BASE_URL+`application/create`;
    const handleChangeDescription = (event) => {
        setDescription(event.target.value);
    };
    const handleChangeName = (event) => {
        setName(event.target.value);
    };

    const handleOnClick = () => {
        const requestData = {
            title: name,
            description: description
        };
        fetch(apiUrl, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(requestData)
        })
            .then(response => response.json())
            .then(data => {
                if(data.error){
                    sessionStorage.setItem("error",data.error);
                    sessionStorage.setItem("message", data.message);
                    window.location.reload();
                }else{
                    const { title, createdAt, validatedAt, options, informations, status, accessId,accounts } = data.object;
                    const newData={
                        "Nom": title || "N/D",
                        "Nombre information":informations.length || 0,
                        "Nombre option": options.length || 0,
                        "Date creation": createdAt || "N/D",
                        "Date validation":validatedAt || "N/D",
                        "Access_id":accessId || "N/D",
                        "Status":status || "N/D"
                    }
                    updateApp(newData);
                    updateAccount(accounts[0].devise, accounts[0].balance);
                    updateAccount(accounts[1].devise, accounts[1].balance);
                    sessionStorage.setItem("appId", data.object.id);
                }
            })
            .catch(error => {
                Swal.fire({
                    title: 'Error!',
                    text:`Oups! Une erreur s'est produite, veuillez reesayer plus tard.`,
                    icon: 'error',
                    confirmButtonText: 'OK',
                    customClass: {
                        popup: 'custom-popup',
                        confirmButton: 'custom-button'
                    },
                    timer: 5000
                });
                console.error('Erreur lors de la requête :', error);
            });
    };

    const remainingChars = minLength - description.length;
    return(
        <div className="modal-content">
            <div className="modal-header">
                <h5 className="modal-title" id="modalFullTitle">{title}</h5>
                <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    aria-label="Close"
                ></button>
            </div>
            <div className="modal-body">
                <div className="col-md-12 d-flex justify-content-center align-items-center">
                    <div className="col-md-6">
                        <div className="form-floating mb-2">
                            <input
                                type="text"
                                className="form-control"
                                id="appName"
                                value={name}
                                onChange={handleChangeName}
                                placeholder="Netikash Shop"
                            />
                            <label htmlFor="appName">Nom de l'application</label>
                        </div>
                        <div>
                            <label htmlFor="appDescription" className="form-label">Description</label>
                            <textarea
                                className="form-control"
                                id="appDescription"
                                value={description}
                                onChange={handleChangeDescription}
                                rows="4"
                                placeholder={"Entrer une description de votre application (minimum "+minLength+" caractères)"}
                            ></textarea>
                            <div>
                                {remainingChars >= 0 ? (
                                    <span>Caractères restants : {remainingChars}</span>
                                ) : (
                                    <span>Minimum de caractères atteint</span>
                                )}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="modal-footer">
                <button type="button" className="btn btn-outline-netikash" data-bs-dismiss="modal">
                    Fermer
                </button>
                <button type="button" className={remainingChars >=0 ? "btn btn-netikash disabled":"btn btn-netikash"} onClick={() => handleOnClick()} data-bs-dismiss="modal">Enregister</button>
            </div>
        </div>
    );
}
